export const PARTNERSHIPS = {
  US_TELCO_COMPARISON: 'us_telco_comparison',
  BOUYGUES_OFFERS_WEBVIEW: 'partnerships-bouygues-offers-webview',
  WEBVIEW_BOUYGUES_OFFERS: 'partnerships-webview-bouygues-offers',
} as const
